import { Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-admin-input',
  standalone: true,
  imports: [FormsModule],
  template: `
    <label class="cg-admin-field">
      @if (label()) {
        <span class="cg-admin-field__label">{{ label() }}</span>
      }
      <input
        class="cg-input"
        [class.font-mono]="mono()"
        [class.text-xs]="mono()"
        [type]="type()"
        [attr.name]="name() || null"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [(ngModel)]="value"
      />
      @if (help()) {
        <span class="cg-form-help">{{ help() }}</span>
      }
      @if (error()) {
        <span class="cg-form-error">{{ error() }}</span>
      }
    </label>
  `,
})
export class AdminInputComponent {
  readonly label = input<string>();
  readonly name = input<string>();
  readonly type = input('text');
  readonly placeholder = input('');
  readonly help = input<string>();
  readonly error = input<string>();
  readonly mono = input(false);
  readonly disabled = input(false);
  readonly value = model<string>('');
}
